module.exports = __webpack_public_path__ + "img/customer-service.7ab0951d.png";